import { useState } from "react";

export function useModals() {
  const [showEntry,           setShowEntry]           = useState(false);
  const [showChangeDate,      setShowChangeDate]      = useState(false);
  const [showMenu,            setShowMenu]            = useState(false);
  const [showShiftSetup,      setShowShiftSetup]      = useState(false);
  const [showImportExcel,     setShowImportExcel]     = useState(false);
  const [showSCCOPicker,      setShowSCCOPicker]      = useState(false);
  const [showAdminPw,         setShowAdminPw]         = useState(false);
  const [showChangePw,        setShowChangePw]        = useState(false);
  const [showExportShift,     setShowExportShift]     = useState(false);
  const [showSCCORoster,      setShowSCCORoster]      = useState(false);
  const [showPhoneDir,        setShowPhoneDir]        = useState(false);
  const [showFeedback,        setShowFeedback]        = useState(false);
  const [showFeedbackInbox,   setShowFeedbackInbox]   = useState(false);
  const [showLoginAlerts,     setShowLoginAlerts]     = useState(false);
  const [showLoginLog,        setShowLoginLog]        = useState(false);
  const [showActivityHeatmap, setShowActivityHeatmap] = useState(false);
  const [showOpsIntel,        setShowOpsIntel]        = useState(false);
  const [showWarRoom,         setShowWarRoom]         = useState(false);
  const [showExpeditor,       setShowExpeditor]       = useState(false);

  return {
    showEntry,           setShowEntry,
    showChangeDate,      setShowChangeDate,
    showMenu,            setShowMenu,
    showShiftSetup,      setShowShiftSetup,
    showImportExcel,     setShowImportExcel,
    showSCCOPicker,      setShowSCCOPicker,
    showAdminPw,         setShowAdminPw,
    showChangePw,        setShowChangePw,
    showExportShift,     setShowExportShift,
    showSCCORoster,      setShowSCCORoster,
    showPhoneDir,        setShowPhoneDir,
    showFeedback,        setShowFeedback,
    showFeedbackInbox,   setShowFeedbackInbox,
    showLoginAlerts,     setShowLoginAlerts,
    showLoginLog,        setShowLoginLog,
    showActivityHeatmap, setShowActivityHeatmap,
    showOpsIntel,        setShowOpsIntel,
    showWarRoom,         setShowWarRoom,
    showExpeditor,       setShowExpeditor,
  };
}
